import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildAutomationEditPath } from '../../../app-routes';
import { useDefaultAutomationMetadata } from '../useAutomationTemplates';
import { CreateTemplateDialog } from './create-template-dialog';
import { DefaultTemplateButtons } from './DefaultTemplateButtons';
import styles from './EngageAutomationsTab.module.css';
import { TemplatesManager } from './templates-manager';
import { TemplatesTableControls } from './TemplatesTableControls';

export const EngageAutomationsTab: React.FC = () => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const navigate = useNavigate();

  const { data: defaultMetadata, isLoading: isLoadingMetadata } =
    useDefaultAutomationMetadata();

  const handleCreateTemplate = () => {
    setCreateDialogOpen(true);
  };

  const handleTemplateCreated = (templateId: string) => {
    navigate(buildAutomationEditPath(templateId));
  };

  return (
    <div className="space-y-6">
      <section className={styles.tabBodyHeader}>
        <div className={styles.headerText}>
          <h2>Automation Templates</h2>
          <p>Manage your automated campaigns</p>
        </div>
        <div className={styles.headerButtons}>
          <TemplatesTableControls onCreateTemplate={handleCreateTemplate} />
        </div>
      </section>

      {!isLoadingMetadata && defaultMetadata?.metadata && (
        <DefaultTemplateButtons metadata={defaultMetadata.metadata} />
      )}
      <CreateTemplateDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
        onTemplateCreated={handleTemplateCreated}
        defaultTemplates={defaultMetadata?.metadata || []}
      />

      <TemplatesManager />
    </div>
  );
};
